import { useContext, useMemo } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import { getSpeechToken } from '../WebChatServices';
// import { createCognitiveServicesSpeechServicesPonyfillFactory } from 'botframework-webchat'; //Components

import { useAsyncMemo } from "use-async-memo";



export const useCognitiveServices = (): any => { 
  // can't be typed. when using useAsyncMemo lib, 
  // returning a function is being executed by react-dom.basicStateReducer (return typeof action === 'function' ? action(state) : action;). we need to return fake wrapper function.
  const [druidWebChatState, druidWebChatDispatch, getState,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

  return useAsyncMemo(async () => {
    const currentState = getState();
    let expireAfter = 0;

    if (druidWebChatState.isVoiceInput && druidWebChatState.speechOptions?.isVoiceChannel && currentState.speechOptions?.speechToken) {
      const createCognitiveServicesSpeechServicesPonyfillFactory = await (await import(
          /* webpackChunkName: "speech" */ 
          'botframework-webchat/lib/createCognitiveServicesSpeechServicesPonyfillFactory')).default;
      return () => createCognitiveServicesSpeechServicesPonyfillFactory(
        {
          credentials: () => {
            const currentState = getState();
            const now = Date.now();
            if (now > expireAfter) {
              expireAfter = now + 300000; // to expire after 5 minutes
              return getSpeechToken({ baseUrl: currentState.mergedChatOptions.baseUrl!, botId: currentState.mergedChatOptions.botId!, oldToken: currentState.speechOptions?.speechToken!, withCredentials: currentState.mergedChatOptions.withCredentials ? "include" : "omit" })
                .then(async res => {
                  const respSpeechToken = await res.json();
                  if (respSpeechToken) {
                    druidWebChatDispatch({
                      type: 'SET_SPEECHOPTIONS', payload: {
                        speechToken: respSpeechToken
                      }
                    })
                  }
                  return {
                    authorizationToken: respSpeechToken || currentState.speechOptions?.speechToken!,
                    region: currentState.speechOptions?.speechRegion!
                  }
                },
                  err => {
                    expireAfter = 0;
                    console.error(err); // try with old token
                    return {
                      authorizationToken: currentState.speechOptions?.speechToken!,
                      region: currentState.speechOptions?.speechRegion!
                    }
                  });

            } else {
              return new Promise(resolve => resolve({
                authorizationToken: currentState.speechOptions?.speechToken!,
                region: currentState.speechOptions?.speechRegion!
              }));
            }

          }
        });
    } else {
      return undefined;
    }
  }, [druidWebChatState.isVoiceInput, getState, druidWebChatState.speechOptions?.isVoiceChannel]);

  // return useMemo(() => {
  //   const currentState = getState();
  //   let expireAfter = 0;

  //   if (druidWebChatState.isVoiceInput && druidWebChatState.speechOptions?.isVoiceChannel && currentState.speechOptions?.speechToken) {
      
  //     return createCognitiveServicesSpeechServicesPonyfillFactory(
  //       {
  //         credentials: () => {
  //           const currentState = getState();
  //           const now = Date.now();
  //           if (now > expireAfter) {
  //             expireAfter = now + 300000; // to expire after 5 minutes
  //             return getSpeechToken({ baseUrl: currentState.mergedChatOptions.baseUrl!, botId: currentState.mergedChatOptions.botId!, oldToken: currentState.speechOptions?.speechToken!, withCredentials: currentState.mergedChatOptions.withCredentials ? "include" : "omit" })
  //               .then(async res => {
  //                 const respSpeechToken = await res.json();
  //                 if (respSpeechToken) {
  //                   druidWebChatDispatch({
  //                     type: 'SET_SPEECHOPTIONS', payload: {
  //                       speechToken: respSpeechToken
  //                     }
  //                   })
  //                 }
  //                 return {
  //                   authorizationToken: respSpeechToken || currentState.speechOptions?.speechToken!,
  //                   region: currentState.speechOptions?.speechRegion!
  //                 }
  //               },
  //                 err => {
  //                   expireAfter = 0;
  //                   console.error(err); // try with old token
  //                   return {
  //                     authorizationToken: currentState.speechOptions?.speechToken!,
  //                     region: currentState.speechOptions?.speechRegion!
  //                   }
  //                 });

  //           } else {
  //             return new Promise(resolve => resolve({
  //               authorizationToken: currentState.speechOptions?.speechToken!,
  //               region: currentState.speechOptions?.speechRegion!
  //             }));
  //           }

  //         }
  //       });
  //   } else {
  //     return undefined;
  //   }
  // }, [druidWebChatState.isVoiceInput, getState, druidWebChatState.speechOptions?.isVoiceChannel]);
}